import { AppAlert } from 'types';

export interface ActionTypes {
  ADD_ALERT: string;
  REMOVE_ALERT: string;
  REMOVE_ALERT_BY_GROUP: string;
  REMOVE_ALL_ALERTS: string;
}

export const AlectsActionTypes: ActionTypes = {
  ADD_ALERT: '@@ADD_ALERT',
  REMOVE_ALERT: '@@REMOVE_ALERT',
  REMOVE_ALERT_BY_GROUP: '@@REMOVE_ALERT_BY_GROUP',
  REMOVE_ALL_ALERTS: '@@REMOVE_ALL_ALERTS'
};

export interface AlectsState {
  data: Array<AppAlert>;
}

export default AlectsActionTypes;
